import React, { Component } from 'react';
// import GoogleLogin from 'react-google-login';
import PropTypes from 'prop-types';
import getSetCookie from '../../../cookie';
// import FacebookLogin from '../../../CommonComponents/FacebookLogin';
import './SocialLogin.scss';

class SocialLogin extends Component {
    static propTypes = {
        social: PropTypes.object,
        socialError: PropTypes.object,
        hideLogin: PropTypes.func,
        commonActions: PropTypes.object,
        registerActions: PropTypes.object,
        // loginValue: PropTypes.any
    };
    constructor(props, context) {
        super(props, context);
        this.state = {
            facebookLoginError: { errorMsg: '' }
        };
    }
    componentDidUpdate(prevProps) {
        const { social, hideLogin, socialError, commonActions } = this.props;
        if (!prevProps.social && social) {
            hideLogin();
            window.localStorage.setItem('reloadRequired', true);
            commonActions.getUserInfo();
            commonActions.shortlist('', 'get', '?attributes=true');
            getSetCookie.setCookieWithDomain('isLogined', 1, 7889400000);
            getSetCookie.setCookie('log_in_status', 'loggedin', 30);
            if (window.prevUrl) window.history.back();
        }
        if (prevProps.socialError === null && socialError && socialError.message) {
            alert(socialError.message);
        }
    }
    componentClicked(data, status) {
        const statusMessage = `${status} with ${data}`;
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.loginPopup.load.socialLogin(data, statusMessage);
    }

    responseFacebook(response) {
        if (!response) {
            return;
        }
        const { registerActions, dataLocale } = this.props;
        const { HI, PLEASE_ALLOW_EMAIL_PERMISSION, USER_CANCELLED_LOGIN } = dataLocale;
        if (response && response.accessToken && response.email !== undefined) {
            const data = {
                accessToken: response.accessToken,
                expires: response.expiresIn,
                idToken: null
            };
            registerActions.socialAuth({ data, account: 'facebook' });
        } else if (response && response.accessToken && response.email === undefined) {
            this.setState({ facebookLoginError: { errorMsg: `${HI}, ${response.name ? response.name : ''} ${PLEASE_ALLOW_EMAIL_PERMISSION}` } });
        } else {
            this.setState({ facebookLoginError: { errorMsg: USER_CANCELLED_LOGIN } });
        }
    }

    responseGoogle(context, response) {
        const { registerActions } = context.props;
        if (response && response.tokenObj && response.tokenObj.access_token) {
            const data = {
                accessToken: response.tokenObj.access_token,
                expires: response.tokenObj.expires_in,
                idToken: response.tokenObj.id_token
            };
            registerActions.socialAuth({ data, account: 'google' });
        }
    }

    render() {
        const { dataLocale, localeInfo } = this.props;
        const { T_C_APPLY } = dataLocale;
        const { domainUrl } = localeInfo;
        return (
            <React.Fragment>
                <div className="social-login">
                    <div className="title">
                        {/* <div className="sign-up-cont">{OR_SIGN_IN_USING}</div> */}
                        {/* <div className="fb_google-cart text-center">
                            <a rel="facebook-connect" className="fb-login fbbutt3 lenskar-fabcebook">
                                <FacebookLogin
                                    triggerTracking={() => this.componentClicked('facebook', this.props.loginValue)}
                                    callback={response => this.responseFacebook(response)}
                                />
                            </a>
                            <a className="google-login gmbutt3 lenskart-google">
                                <GoogleLogin
                                    clientId="630722614748-r4u7jgn36k7p1tut83sa00v5g48kr6gl.apps.googleusercontent.com"
                                    uxMode="popup"
                                    scope="profile email"
                                    responseType="id_token permission"
                                    buttonText=""
                                    style={{ backgroundImage: 'url(//static.lenskart.com/media/wysiwyg/sign-register/g-plus_n.jpg)', width: '162px', height: '42px', border: '0px', float: 'right' }}
                                    onSuccess={response => { this.responseGoogle(this, response); }}
                                    onFailure={response => { this.responseGoogle(this, response); }}
                                    onRequest={() => { this.componentClicked('google', this.props.loginValue); }}
                                />
                            </a>
                        </div> */}
                    </div>
                    {this.state.facebookLoginError.errorMsg !== '' && <p className="text-red margin-t5 clear-both float-left">{this.state.facebookLoginError.errorMsg}</p>}
                </div>
                <div className="terms">
                    <a href={`//${domainUrl}/terms-conditions`} target="_blank" rel="noopener noreferrer">*{T_C_APPLY}</a>
                </div>
            </React.Fragment>
        );
    }
}

export default SocialLogin;
